import TripHomepageContainer from './TripHomepageContainer'

export default TripHomepageContainer
